import { Injectable } from '@angular/core';
import { CanMatch, Router } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanMatch {
  constructor(
    private navCtrl: NavController,
    private api: ApiService,
    private router: Router,
  ) {}

  canMatch(): Observable<boolean> {
    return this.api.isUser.pipe(
      //tap((res) => console.log(res)),
      filter((val) => val !== null),
      take(1),
      map((isAuthd) => {
        if (isAuthd) {
          return true;
        } else {
          this.navCtrl.setDirection('root');
          this.router.navigateByUrl('/login');
          return false;
        }
      }),
    );
  }
}
